import { getItem, setItem } from 'owa-local-storage';

/**
 * localStorage hint for whether all-day events are shown in the MyOutlook Today
 * calendar widget grid.
 *
 * Hidden by default; once the user shows all-day events via the in-grid toggle we
 * remember it so the widget reopens in their last known state. Scoped to the
 * widget only — calendar surface views are unaffected.
 */

const ALLDAY_VISIBLE_KEY = 'owa-personal-os-schedule-allday-visible';

/**
 * Reads the persisted all-day-events visibility preference. Returns `false` (the
 * hidden default) when no explicit choice has been recorded yet.
 */
export function getStoredAllDayEventsVisible(): boolean {
    return getItem(self, ALLDAY_VISIBLE_KEY) === 'true';
}

/**
 * Records the user's explicit all-day show/hide so the next widget visit
 * defaults to this state.
 */
export function setStoredAllDayEventsVisible(visible: boolean): void {
    setItem(self, ALLDAY_VISIBLE_KEY, visible ? 'true' : 'false');
}
